import React, { useMemo, useCallback, useEffect, useState } from 'react';
import {
  Form,
  notification,
  Popconfirm,
  Button as AntdButton,
  Button,
  Row,
} from 'antd';
import { useQuery } from 'react-query';
import { useFormList } from '../../../hooks/useFormList';
import DataGrid, { DataGridColDef } from '../../DataGrid/DataGrid';
import {
  MguserlandingResponse,
  getMguserlandingBymgidUserid,}from '../../../services/parametersService';
  import { getMyFavorite,
  MgUsersFavoriteResponse,
  removeFavorite,
  addFavorite,
} from '../../../services/workflow';

import { indexBy } from '../../../utils/utils2';
import ListOfTasks from './ListOfTasks';
import { getCurrentUser } from 'utils/APIUtils';
import { useHistory } from 'react-router';
import MgCompanyList from '../../MgCompanyList/index';
import { isEqual } from 'lodash';
import UpdateButton from 'components/UpdateButtonAction';
import DeleteButton from 'components/DeleteButton';
import { ArrowDownOutlined, ArrowUpOutlined } from '@ant-design/icons';
const NEW_ACTION_ID = -1;
const NEW_CONFIG_ID = -1;

type Values = {
  actions: MguserlandingResponse[];
};
type ValuesActions = {
  actions: MgUsersFavoriteResponse[];
};

export type MyProfileProps = {
  onCancel: () => void;
};

const MyTasks = ({ onCancel }: MyProfileProps) => {
  const [Params] = useState<any>({
    part1show: false,
    part2show: false,
    part3show: false,
  });
  const [mgName, SetmgName] = useState<any>(localStorage.getItem('mgname'));
  const history = useHistory();
  const [configForm] = Form.useForm();
  const [myProfileForm] = Form.useForm();
  const [quickActionsForm] = Form.useForm();

  const fieldNameOfquickAction = 'actions';
  const fieldName = 'mg';

  const { data: user, isFetching } = useQuery(`getCurrentUser`, () =>
    getCurrentUser().then((res) => {
      myProfileForm.setFieldsValue({
        mgid: res.mgid,
        lancode: res.lancode,
        route: res.route,
        tabposition: res.tabposition,
        name: res.name,
        username: res.username,
        phone: res.phone,
        mobile: res.mobile,
        usertype: res.usertype,
        surname: res.surname,
        email: res.email,
      });
      return res;
    })
  );

  const { data, refetch } = useQuery(
    ['getMguserlandingBymgidUserid', {}],
    () => getMguserlandingBymgidUserid().then((res) => res.list || []),
    { refetchOnMount: false }
  );
  const {
    data: dataAction,
    refetch: refetchAction,
    isFetching: isFetchingAction,
  } = useQuery(
    ['getMyFavorite', {}],
    () => getMyFavorite().then((res) => res.list || []),
    { refetchOnMount: false }
  );

  useEffect(() => {
    if (data) {
      configForm.setFieldsValue({ [fieldName]: data });
    } else {
      configForm.setFieldsValue({
        [fieldName]: [],
      });
    }
    if (dataAction) {
      quickActionsForm.setFieldsValue({ [fieldNameOfquickAction]: dataAction });
    } else {
      quickActionsForm.setFieldsValue({
        [fieldNameOfquickAction]: [],
      });
    }
  }, [configForm, quickActionsForm, data, dataAction]);

  const { add, remove } = useFormList(configForm, fieldName, {
    idKey: 'partid',
    addAsFirst: true,
  });
  const { add: addd, remove: removeFav } = useFormList(
    quickActionsForm,
    fieldNameOfquickAction,
    {
      idKey: 'favoriteid',
      addAsFirst: true,
    }
  );

  const getName = useCallback(
    (name: string) => (record: MguserlandingResponse) => {
      const actions = configForm.getFieldValue(fieldName);
      const index = indexBy(actions, 'partid')[record.partid];
      return [fieldName, index, name];
    },
    [configForm]
  );
  const getNameOfquickAction = useCallback(
    (name: string) => (record: MgUsersFavoriteResponse) => {
      const actions = quickActionsForm.getFieldValue(fieldNameOfquickAction);
      const index = indexBy(actions, 'favoriteid')[record.favoriteid];
      return [fieldNameOfquickAction, index, name];
    },
    [quickActionsForm]
  );
  // const onSave = useCallback(
  //   (record: MguserlandingResponse) => {
  //     const functions: MguserlandingResponse[] =
  //       configForm.getFieldValue(fieldName);
  //     const index = indexBy(functions, 'partid')[record.partid];
  //     const currentValue = functions[index];

  //     const { mgid, partid } = currentValue;
  //     if (mgid) {
  //       partid === NEW_CONFIG_ID
  //         ? addMguserlandingBymgidUserid({
  //             request: {
  //               ...currentValue,
  //               partid: NEW_CONFIG_ID,
  //             },
  //           }).then((response) => {
  //             if (response.code === '200') {
  //               notification.success({
  //                 message: `Created`,
  //               });
  //               refetch();
  //             } else {
  //               notification.error({
  //                 message: response.message,
  //                 description: response.description,
  //               });
  //             }
  //           })
  //         : UpdateMguserlanding({
  //             partid: currentValue.partid,
  //             request: currentValue,
  //           }).then((response) => {
  //             if (response.code === '200') {
  //               notification.success({
  //                 message: response.message,
  //               });
  //               refetch();
  //             }
  //           });
  //     } else {
  //       notification.error({
  //         message: 'Please select Company',
  //       });
  //     }
  //   },
  //   [configForm, refetch]
  // );

  // const columns = useMemo<DataGridColDef<MguserlandingResponse>[]>(
  //   () => [
  //     {
  //       dataIndex: 'mgid',
  //       render: (value, record) => {
  //         return record.partid === NEW_CONFIG_ID ? (
  //           <Form.Item noStyle name={getName('mgid')(record)}>
  //             <MgCompanyList />
  //           </Form.Item>
  //         ) : (
  //           record.mgname
  //         );
  //       },
  //       width: 200,
  //     },
  //     {
  //       dataIndex: 'partorder',
  //       render: (value, record) => (
  //         <Form.Item noStyle name={getName('partorder')(record)}>
  //           <InputNumber max={5} min={1} step={1} />
  //         </Form.Item>
  //       ),
  //       width: 200,
  //     },

  //     {
  //       dataIndex: 'part1type',
  //       render: (value, record) => {
  //         Params.part1show = value !== 'Chart';
  //         return (
  //           <Form.Item noStyle name={getName('part1type')(record)}>
  //             <ParListSelect
  //               parcode="PARTTYPE"
  //               onChange={(e, k) => {
  //                 Params.part1show = e !== 'Chart';
  //               }}
  //               allowClear
  //             />
  //           </Form.Item>
  //         );
  //       },
  //       width: 200,
  //     },
  //     {
  //       dataIndex: 'part1width',
  //       render: (value, record) => (
  //         <Form.Item name={getName('part1width')(record)}>
  //           <InputNumber min={4} max={24} />
  //         </Form.Item>
  //       ),
  //       width: 200,
  //     },
  //     {
  //       dataIndex: 'part1height',
  //       render: (value, record) => (
  //         <Form.Item noStyle name={getName('part1height')(record)}>
  //           <Input min={100} max={800} />
  //         </Form.Item>
  //       ),
  //       width: 200,
  //     },
  //     {
  //       dataIndex: 'part1label',
  //       render: (value, record) => (
  //         <Form.Item noStyle name={getName('part1label')(record)}>
  //           <Input />
  //         </Form.Item>
  //       ),
  //       width: 200,
  //     },
  //     {
  //       dataIndex: 'part1graph',
  //       render: (value, record) => (
  //         <Form.Item noStyle name={getName('part1graph')(record)}>
  //           <ParListSelect
  //             parcode="CHARTTYPE"
  //             allowClear
  //             disabled={Params.part1show}
  //           />
  //         </Form.Item>
  //       ),
  //       width: 200,
  //     },
  //     {
  //       dataIndex: 'part1view',
  //       render: (value, record) => (
  //         <Form.Item noStyle name={getName('part1view')(record)}>
  //           <ParListSelect
  //             parcode="CHARTVIEW"
  //             allowClear
  //             disabled={Params.part1show}
  //           />
  //         </Form.Item>
  //       ),
  //       width: 200,
  //     },
  //     {
  //       dataIndex: 'part1kpi',
  //       render: (value, record) => (
  //         <Form.Item noStyle name={getName('part1kpi')(record)}>
  //           <ParListSelect
  //             parcode="STPRDKPI"
  //             allowClear
  //             disabled={Params.part1show}
  //           />
  //         </Form.Item>
  //       ),
  //       width: 200,
  //     },
  //     {
  //       dataIndex: 'part2type',
  //       render: (value, record) => {
  //         Params.part1show = value !== 'Chart';
  //         return (
  //           <Form.Item noStyle name={getName('part2type')(record)}>
  //             <ParListSelect
  //               parcode="PARTTYPE"
  //               onChange={(e, k) => {
  //                 Params.part2show = e !== 'Chart';
  //               }}
  //               allowClear
  //             />
  //           </Form.Item>
  //         );
  //       },
  //       width: 200,
  //     },
  //     {
  //       dataIndex: 'part2width',
  //       render: (value, record) => (
  //         <Form.Item name={getName('part2width')(record)}>
  //           <InputNumber min={4} max={24} />
  //         </Form.Item>
  //       ),
  //       width: 200,
  //     },
  //     {
  //       dataIndex: 'part2height',
  //       render: (value, record) => (
  //         <Form.Item noStyle name={getName('part2height')(record)}>
  //           <InputNumber min={100} max={800} />
  //         </Form.Item>
  //       ),
  //       width: 200,
  //     },
  //     {
  //       dataIndex: 'part2label',
  //       render: (value, record) => (
  //         <Form.Item noStyle name={getName('part2label')(record)}>
  //           <Input />
  //         </Form.Item>
  //       ),
  //       width: 200,
  //     },
  //     {
  //       dataIndex: 'part2graph',
  //       render: (value, record) => (
  //         <Form.Item noStyle name={getName('part2graph')(record)}>
  //           <ParListSelect
  //             parcode="CHARTTYPE"
  //             allowClear
  //             disabled={Params.part2show}
  //           />
  //         </Form.Item>
  //       ),
  //       width: 200,
  //     },
  //     {
  //       dataIndex: 'part2view',
  //       render: (value, record) => (
  //         <Form.Item noStyle name={getName('part2view')(record)}>
  //           <ParListSelect
  //             parcode="CHARTVIEW"
  //             allowClear
  //             disabled={Params.part2show}
  //           />
  //         </Form.Item>
  //       ),
  //       width: 200,
  //     },
  //     {
  //       dataIndex: 'part2kpi',
  //       render: (value, record) => (
  //         <Form.Item noStyle name={getName('part2kpi')(record)}>
  //           <ParListSelect
  //             parcode="STPRDKPI"
  //             allowClear
  //             disabled={Params.part2show}
  //           />
  //         </Form.Item>
  //       ),
  //       width: 200,
  //     },
  //     {
  //       dataIndex: 'part3type',
  //       render: (value, record) => {
  //         Params.part1show = value !== 'Chart';
  //         return (
  //           <Form.Item noStyle name={getName('part3type')(record)}>
  //             <ParListSelect
  //               parcode="PARTTYPE"
  //               onChange={(e, k) => {
  //                 Params.part3show = e !== 'Chart';
  //               }}
  //               allowClear
  //             />
  //           </Form.Item>
  //         );
  //       },
  //       width: 200,
  //     },
  //     {
  //       dataIndex: 'part3width',
  //       render: (value, record) => (
  //         <Form.Item name={getName('part3width')(record)}>
  //           <InputNumber min={4} max={24} />
  //         </Form.Item>
  //       ),
  //       width: 200,
  //     },
  //     {
  //       dataIndex: 'part3height',
  //       render: (value, record) => (
  //         <Form.Item noStyle name={getName('part3height')(record)}>
  //           <InputNumber min={100} max={800} />
  //         </Form.Item>
  //       ),
  //       width: 200,
  //     },
  //     {
  //       dataIndex: 'part3label',
  //       render: (value, record) => (
  //         <Form.Item noStyle name={getName('part3label')(record)}>
  //           <Input />
  //         </Form.Item>
  //       ),
  //       width: 200,
  //     },
  //     {
  //       dataIndex: 'part3graph',
  //       render: (value, record) => (
  //         <Form.Item noStyle name={getName('part3graph')(record)}>
  //           <ParListSelect
  //             parcode="CHARTTYPE"
  //             allowClear
  //             disabled={Params.part3show}
  //           />
  //         </Form.Item>
  //       ),
  //       width: 200,
  //     },
  //     {
  //       dataIndex: 'part3view',
  //       render: (value, record) => (
  //         <Form.Item noStyle name={getName('part3view')(record)}>
  //           <ParListSelect
  //             parcode="CHARTVIEW"
  //             allowClear
  //             disabled={Params.part3show}
  //           />
  //         </Form.Item>
  //       ),
  //       width: 200,
  //     },
  //     {
  //       dataIndex: 'part3kpi',
  //       render: (value, record) => (
  //         <Form.Item noStyle name={getName('part3kpi')(record)}>
  //           <ParListSelect
  //             parcode="STPRDKPI"
  //             allowClear
  //             disabled={Params.part3show}
  //           />
  //         </Form.Item>
  //       ),
  //       width: 200,
  //     },
  //     {
  //       dataIndex: 'userid',
  //       render: (value, record) => (
  //         <Form.Item noStyle name={getName('userid')(record)}>
  //           <Value />
  //         </Form.Item>
  //       ),
  //       width: 200,
  //     },
  //     {
  //       key: 'remove',
  //       fixed: 'right',
  //       render: (_, record) => (
  //         <Popconfirm
  //           title="Are you sure to delete this action?"
  //           onConfirm={() => {
  //             if (record.partid !== NEW_CONFIG_ID) {
  //               removeMguserlanding({
  //                 partid: record.partid,
  //               }).then(() => refetch());
  //             } else {
  //               remove(record.partid);
  //             }
  //           }}
  //           okText="Yes"
  //           cancelText="No"
  //         >
  //           <AntdButton size="small">Delete</AntdButton>
  //         </Popconfirm>
  //       ),
  //       width: 100,
  //     },
  //     {
  //       key: 'save',
  //       fixed: 'right',
  //       render: (_, record) =>
  //         record.partid === NEW_CONFIG_ID ? (
  //           <AntdButton size="small" onClick={() => onSave(record)}>
  //             Save
  //           </AntdButton>
  //         ) : (
  //           <AntdButton size="small" onClick={() => onSave(record)}>
  //             Update
  //           </AntdButton>
  //         ),
  //       width: 100,
  //     },
  //   ],
  //   [Params, getName, onSave, refetch, remove]
  // );

  const addRow = () => {
    const row: MguserlandingResponse = {
      mgid: user.mgid,
      mgname: user.mgname,
      part1graph: '',
      part1height: 0,
      part1kpi: '',
      part1label: '',
      part1type: '',
      part1view: '',
      part1width: 0,
      partid: NEW_CONFIG_ID,
      partorder: 0,
      userid: user.id,
      part1graphLabel: '',
      part1kpiLabel: '',
      part1typeLabel: '',
      part1viewLabel: '',
      part2graph: '',
      part2height: 0,
      part2kpi: '',
      part2label: '',
      part2type: '',
      part2view: '',
      part2width: 0,
      part2graphLabel: '',
      part2kpiLabel: '',
      part2typeLabel: '',
      part2viewLabel: '',
      part3graph: '',
      part3height: 0,
      part3kpi: '',
      part3label: '',
      part3type: '',
      part3view: '',
      part3width: 0,
      part3graphLabel: '',
      part3kpiLabel: '',
      part3typeLabel: '',
      part3viewLabel: '',
    };
    add(row);
  };

  const onSaveOfquickActions = (record: MgUsersFavoriteResponse) => {
    const functions: MgUsersFavoriteResponse[] = quickActionsForm.getFieldValue(
      fieldNameOfquickAction
    );
    const index = indexBy(functions, 'favoriteid')[record.favoriteid];
    const currentValue = functions[index];

    const { mgid, taskid, favoriteid } = currentValue;
    if (mgid) {
      favoriteid === NEW_ACTION_ID &&
        addFavorite({ request: { mgid, taskid } }).then((response) => {
          if (response.code === '200') {
            notification.success({
              message: `Created`,
            });
            refetchAction();
          } else {
            notification.error({
              message: response.message,
              description: response.description,
            });
          }
        });
    } else {
      notification.error({
        message: 'Please select Company',
      });
    }
  };

  const columnsOfquickActions = useMemo<
    DataGridColDef<MgUsersFavoriteResponse>[]
  >(
    () => [
      {
        dataIndex: 'order',
        width: 50,
        render: () => (
          <Row justify="center">
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <Button
                size="small"
                type="primary"
                style={{ marginRight: '3px' }}
                icon={<ArrowUpOutlined />}
                shape="circle"
              ></Button>
              <Button
                style={{ backgroundColor: '#DF0000', borderColor: '#DF0000' }}
                size="small"
                type="primary"
                icon={<ArrowDownOutlined className='icon-bold' style={{ fontWeight: 'bold' }} />}
                shape="circle"
              ></Button>
            </div>
          </Row>
        ),
      },
      {
        dataIndex: 'mgid',
        render: (value, record) => {
          return record.favoriteid === NEW_ACTION_ID ? (
            <Form.Item noStyle name={getNameOfquickAction('mgid')(record)}>
              <MgCompanyList />
            </Form.Item>
          ) : (
            record.mgname
          );
        },
        width: 200,
      },
      {
        dataIndex: 'taskid',
        render: (value, record) => {
          return record.favoriteid === NEW_ACTION_ID ? (
            <Form.Item noStyle name={getNameOfquickAction('taskid')(record)}>
              <ListOfTasks />
            </Form.Item>
          ) : (
            record.tasklabel
          );
        },
        width: 200,
      },
      {
        key: 'actions',
        align: 'center',
        render: (_, record, index) =>
          record.favoriteid === NEW_ACTION_ID ? (
            <>
              <UpdateButton
                comcode="save"
                onClick={() =>
                  onSaveOfquickActions(
                    quickActionsForm.getFieldValue([
                      fieldNameOfquickAction,
                      index,
                    ])
                  )
                }
              />
              <Popconfirm
                title="Are you sure to delete this action?"
                onConfirm={() => {
                  if (record.favoriteid !== NEW_ACTION_ID) {
                    removeFavorite({
                      favoriteid: record.favoriteid,
                    }).then(() => refetchAction());
                  } else {
                    removeFav(record.favoriteid);
                  }
                }}
                okText="Yes"
                cancelText="No"
              >
                <DeleteButton onlyIcon />
              </Popconfirm>
            </>
          ) : (
            <Popconfirm
              title="Are you sure to delete this action?"
              onConfirm={() => {
                if (record.favoriteid !== NEW_ACTION_ID) {
                  removeFavorite({
                    favoriteid: record.favoriteid,
                  }).then(() => refetchAction());
                } else {
                  remove(record.favoriteid);
                }
              }}
              okText="Yes"
              cancelText="No"
            >
              <DeleteButton onlyIcon />
            </Popconfirm>
          ),
        width: 90,
      },
    ],
    [getNameOfquickAction, refetchAction, remove, onSaveOfquickActions]
  );

  const addRowOfquickActions = () => {
    const row: MgUsersFavoriteResponse = {
      favoriteid: NEW_ACTION_ID,
      id: 0,
      mgid: '' as any,
      taskid: '' as any,
      mgname: '',
      tasklabel: '',
    };
    addd(row);
  };

  return (
    <div>
      <br />
      <br />
      <Form form={quickActionsForm} name={fieldNameOfquickAction}>
        <Form.Item
          noStyle
          shouldUpdate={(
            prevValue: ValuesActions,
            nextValue: ValuesActions
          ) => {
            return !isEqual(prevValue, nextValue);
          }}
        >
          {({ getFieldValue }) => {
            const actions: MgUsersFavoriteResponse[] = getFieldValue(
              fieldNameOfquickAction
            );
            const isNewItemInTable =
              actions?.find(
                ({ favoriteid }) => favoriteid === NEW_ACTION_ID
              ) !== undefined;
            return (
              <DataGrid
                rowKey="favoriteid"
                dataSource={actions}
                columns={columnsOfquickActions}
                isLoading={isFetchingAction}
                titleComcode="quickActions"
                hideFilters
                extraActions={
                  <AntdButton
                    type="primary"
                    // icon={<PlusOutlined />}
                    onClick={addRowOfquickActions}
                    disabled={isNewItemInTable}
                  >
                    Add NEW
                  </AntdButton>
                }
              />
            );
          }}
        </Form.Item>
      </Form>
    </div>
  );
};

export default MyTasks;
